import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import LightBox from "@/components/LightBox";
import styles from "@/styles/Watch.module.scss";
import Image from "next/legacy/image";
import { useCallback, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var IconZoomIn = function IconZoomIn(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      stroke: "#646464",
      strokeWidth: ".125",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m23.838 22.525-5.884-5.885a10.101 10.101 0 0 0 2.344-6.479c0-5.596-4.553-10.149-10.15-10.149C4.554.012 0 4.565 0 10.162c0 5.595 4.553 10.147 10.149 10.147 2.46 0 4.72-.88 6.479-2.343l5.885 5.884a.938.938 0 1 0 1.326-1.326zM1.875 10.16c0-4.562 3.712-8.274 8.274-8.274 4.562 0 8.274 3.712 8.274 8.274 0 4.562-3.712 8.274-8.274 8.274-4.562 0-8.274-3.712-8.274-8.274z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      stroke: "#646464",
      strokeWidth: ".125",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14.754 9.223h-3.668V5.555a.937.937 0 1 0-1.875 0v3.668H5.543a.938.938 0 0 0 0 1.875h3.668v3.668a.937.937 0 1 0 1.875 0v-3.668h3.668a.938.938 0 0 0 0-1.875z"
    })]
  }));
};
IconZoomIn.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
export default function WatchThumbnail(_ref) {
  let {
    src,
    alt
  } = _ref;
  const {
    0: show,
    1: setShow
  } = useState(false);
  const toggle = useCallback(() => {
    setShow(show => !show);
  }, []);
  if (!src) return null;
  const images = [src];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.watchThumbnail,
      onClick: toggle,
      children: [!!src && /*#__PURE__*/_jsx(Image, {
        src: src,
        alt: alt,
        layout: "fill",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx("span", {
        className: styles.zoomIcon,
        children: /*#__PURE__*/_jsx(IconZoomIn, {})
      })]
    }), /*#__PURE__*/_jsx(LightBox, {
      show: show,
      images: images,
      onClose: toggle
    })]
  });
}